// extracted by mini-css-extract-plugin
module.exports = {"main":"Tabs_main__133aS","tab":"Tabs_tab__1IhWs","activeTab":"Tabs_activeTab__3GjbP"};